// src/context/ModemViewerContext.jsx
import React, { createContext, useContext, useState, useCallback } from "react";
import ModemViewerDialog from "../components/ModemViewerDialog";

const ModemViewerContext = createContext(null);

export const ModemViewerProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [modemId, setModemId] = useState(null);

  const openViewer = useCallback((id) => {
    setModemId(id);
    setOpen(true);
  }, []);

  const closeViewer = useCallback(() => {
    setOpen(false);
    setModemId(null);
  }, []);

  return (
    <ModemViewerContext.Provider value={{ openModemViewer: openViewer }}>
      {children}
      {/* el modal vive aquí */}
      <ModemViewerDialog open={open} onClose={closeViewer} modemId={modemId} />
    </ModemViewerContext.Provider>
  );
};

export const useModemViewer = () => {
  const ctx = useContext(ModemViewerContext);
  if (!ctx) throw new Error("useModemViewer debe usarse dentro de ModemViewerProvider");
  return ctx;
};
